exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".div-center{margin:0 auto}.vertical-alignment-helper{display:table;height:100%;width:100%;pointer-events:none}.vertical-align-center{display:table-cell;vertical-align:middle;pointer-events:none;width:80%;margin:auto}.modal-content{width:inherit;max-width:inherit;height:inherit;margin:0 auto;pointer-events:all}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./src/assets/css/custom.css
// module id = 49
// module chunks = 0